"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCUnifiedPlan_1 = __importDefault(require("./VoxeetRTCUnifiedPlan"));
const debug_1 = __importDefault(require("debug"));
const Exceptions_1 = require("../Exceptions");
/**
 * @ignore
 */
const debug = debug_1.default('vxt:rtc:electron');
/**
 * @ignore
 */
const ConferenceDisconnectedError = (msg) => new Exceptions_1.DvcError('ConferenceDisconnectedError', msg);
/**
 * @ignore
 */
const FatalError = (msg) => new Exceptions_1.DvcError('FatalError', msg);
const getMediaDescriptions = (sdp) => {
    const mediaDescriptionPrefix = 'm=';
    return sdp
        .split(mediaDescriptionPrefix)
        .slice(1)
        .map((section) => mediaDescriptionPrefix + section);
};
const getMediaDescriptionMid = (mediaDescription) => {
    const re = /^a=mid:(.*)$/m;
    const res = re.exec(mediaDescription);
    if (!res || res.length < 2)
        return null;
    return res[1];
};
const mediaDescriptionHasMid = (mediaDescription, mid) => {
    const mediaDescriptionMid = getMediaDescriptionMid(mediaDescription);
    return mediaDescriptionMid ? mediaDescriptionMid === mid : false;
};
const isCodecPresentInMediaDescription = (sdp, mid, codec) => {
    const mediaDescriptions = getMediaDescriptions(sdp);
    const mediaDescription = mediaDescriptions.find((m) => mediaDescriptionHasMid(m, mid));
    if (!mediaDescription)
        return false;
    return RegExp('^a=rtpmap:.*' + codec + '.*$', 'm').test(mediaDescription);
};
class DVC2FakeAudioTrackHelper {
    constructor(audioContext) {
        this.audioContext = audioContext;
        this.oscillator = null;
        this.fakeAudioSendStream = null;
    }
    release() {
        this.stopFakeAudioSendStreamTrack();
    }
    addMasterStream(peer, stream, addTrackCb) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!stream) {
                yield this.addFakeAudioSendStreamTrack(peer.connection, stream, addTrackCb);
            }
        });
    }
    addStream(stream, pc, addTrackCb) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!stream.getAudioTracks().length) {
                yield this.addFakeAudioSendStreamTrack(pc, stream, addTrackCb);
            }
        });
    }
    addTrack(track, pc, stream, addTrackCb) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeFakeAudioSendStreamTrack(track, pc, stream, addTrackCb);
        });
    }
    removeTrack(pc, stream, replaceTrackCb) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addFakeAudioSendStreamTrack(pc, stream, replaceTrackCb);
        });
    }
    //TODO: mark the methods below as private
    addFakeAudioSendStreamTrack(pc, stream, addTrackCb) {
        return __awaiter(this, void 0, void 0, function* () {
            pc.dvc().setListenerMode(true);
            yield addTrackCb(this.startFakeAudioSendStreamTrack(), pc, stream);
        });
    }
    removeFakeAudioSendStreamTrack(track, pc, stream, addTrackCb) {
        return __awaiter(this, void 0, void 0, function* () {
            yield addTrackCb(track, pc, stream);
            this.stopFakeAudioSendStreamTrack();
            pc.dvc().setListenerMode(false);
            track.enabled = false; // workaround for DVC_SetMute not being called
            track.enabled = true;
        });
    }
    startFakeAudioSendStreamTrack() {
        if (!this.fakeAudioSendStream) {
            this.oscillator = this.audioContext.createOscillator();
            this.fakeAudioSendStream = this.audioContext.createMediaStreamDestination();
            this.oscillator.connect(this.fakeAudioSendStream);
            this.oscillator.start();
        }
        return this.fakeAudioSendStream.stream.getAudioTracks()[0];
    }
    stopFakeAudioSendStreamTrack() {
        if (!this.fakeAudioSendStream)
            return;
        this.oscillator.stop();
        this.oscillator.disconnect();
        this.oscillator = null;
        this.fakeAudioSendStream = null;
    }
}
class VoxeetRTCElectron extends VoxeetRTCUnifiedPlan_1.default {
    constructor() {
        super();
        this.engine = null;
        this.dvcConference = null;
        this.dvc = null;
        this.listenOnly = false;
        this.dvc2FakeAudioTrackHelper = null;
    }
    init({ constraints, processCb, listenOnly, ownerId, options }) {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this, { constraints, processCb, listenOnly, ownerId, options });
            this.listenOnly = listenOnly;
        });
    }
    db2vu(decibels) {
        const dbrange = 100;
        const dblimit = -100;
        if (decibels === -Infinity || decibels < dblimit)
            return 0;
        if (decibels >= dbrange + dblimit)
            return 1;
        //Normalize value to be in between 0 and 1;
        let normDB = decibels / dbrange;
        let scaled = Math.PI / 2 + (Math.PI / 2) * normDB;
        //Apply scale
        let normalized = 1 - Math.cos(scaled);
        return normalized > 1 ? 1 : normalized;
    }
    addPeer({ peerId, description, candidates, isMaster, state = 'default' }) {
        const _super = Object.create(null, {
            addPeer: { get: () => super.addPeer }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.addPeer.call(this, { peerId, description, candidates, isMaster, state });
            const peer = this.peers.find((c) => c.peerId === peerId);
            if (peer && peer.isMaster) {
                this.dvcConference = peer.connection.dvc();
                this.dvcConference.setConferenceDisconnectedErrorCallback(this.conferenceDisconnectedErrorCallback.bind(this));
                this.dvc = new DolbyVoice();
                this.dvc.setFatalErrorCallback(this.fatalErrorCallback.bind(this));
            }
        });
    }
    configureStateDump(audioLoggingLength = 60) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.dvc)
                throw Exceptions_1.ConferenceUninitializedError();
            VoxeetRTCElectron.throwIfNotSupported(this.dvc, 'setAudioLoggingLength');
            return this.dvc.setAudioLoggingLength(audioLoggingLength);
        });
    }
    getStateDumpConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.dvc)
                throw Exceptions_1.ConferenceUninitializedError();
            VoxeetRTCElectron.throwIfNotSupported(this.dvc, 'getAudioLoggingLength');
            return this.dvc.getAudioLoggingLength();
        });
    }
    createStateDump(liteMode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.dvcConference)
                throw Exceptions_1.ConferenceUninitializedError();
            VoxeetRTCElectron.throwIfNotSupported(this.dvcConference, 'createStateDump');
            if (!liteMode)
                return this.dvcConference.createStateDump();
            // Don't attach audio logging when liteMode is enabled
            // Set audioLoggingLength to zero before create a state dump
            const audioLoggingLength = yield this.getStateDumpConfiguration();
            if (audioLoggingLength != 0)
                yield this.configureStateDump(0);
            const dump = yield this.dvcConference.createStateDump();
            // Restore the previous state dump configuration
            if (audioLoggingLength != 0)
                yield this.configureStateDump(audioLoggingLength);
            return dump;
        });
    }
    getLevel(peerId, callback) {
        const peer = this.peers.find((p) => p.peerId === peerId);
        if (peer && peer.isMaster) {
            callback(0);
        }
        else if (peer && !peer.isMaster) {
            this.dvcConference
                .getTalkingLevels()
                .then((levels) => {
                // IDs from DVWC have the format <guid1>@<guid2>, where <guid1> is peer ID
                const level = levels.find((l) => l.clientId.split('@')[0] === peerId);
                callback(level.talkingLevel);
            })
                .catch((err) => callback(0));
        }
        else {
            callback(0);
        }
    }
    setRemoteDescription(peerId, ssrc, type, sdp, cb) {
        const _super = Object.create(null, {
            setRemoteDescription: { get: () => super.setRemoteDescription }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.setRemoteDescription.call(this, peerId, ssrc, type, sdp, cb);
            if (isCodecPresentInMediaDescription(sdp, 'audio', 'DVC-2') && !this.dvc2FakeAudioTrackHelper)
                this.dvc2FakeAudioTrackHelper = new DVC2FakeAudioTrackHelper(this.audioContext);
        });
    }
    addMasterStream(peer) {
        const _super = Object.create(null, {
            addMasterStream: { get: () => super.addMasterStream },
            addTrack: { get: () => super.addTrack }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.addMasterStream.call(this, peer);
            if (this.dvc2FakeAudioTrackHelper) {
                return this.dvc2FakeAudioTrackHelper.addMasterStream(peer, this.localMediaStream, (fakeTrack, pc, stream) => __awaiter(this, void 0, void 0, function* () { return _super.addTrack.call(this, fakeTrack, pc, stream); }));
            }
        });
    }
    addStream(stream, pc) {
        const _super = Object.create(null, {
            addStream: { get: () => super.addStream },
            addTrack: { get: () => super.addTrack }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.addStream.call(this, stream, pc);
            if (this.dvc2FakeAudioTrackHelper) {
                return this.dvc2FakeAudioTrackHelper.addStream(stream, pc, (fakeTrack, pc, stream) => __awaiter(this, void 0, void 0, function* () { return _super.addTrack.call(this, fakeTrack, pc, stream); }));
            }
        });
    }
    addTrack(track, pc, stream) {
        const _super = Object.create(null, {
            addTrack: { get: () => super.addTrack }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (this.dvc2FakeAudioTrackHelper && track.kind === 'audio') {
                return this.dvc2FakeAudioTrackHelper.addTrack(track, pc, stream, (fakeTrack, pc, stream) => __awaiter(this, void 0, void 0, function* () { return _super.addTrack.call(this, fakeTrack, pc, stream); }));
            }
            yield _super.addTrack.call(this, track, pc, stream);
        });
    }
    removeTrack(track, pc, stream) {
        const _super = Object.create(null, {
            replaceTrack: { get: () => super.replaceTrack },
            removeTrack: { get: () => super.removeTrack }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (this.dvc2FakeAudioTrackHelper && track.kind === 'audio') {
                return this.dvc2FakeAudioTrackHelper.removeTrack(pc, stream, (fakeTrack, pc, stream) => __awaiter(this, void 0, void 0, function* () { return _super.replaceTrack.call(this, fakeTrack, pc, stream); }));
            }
            yield _super.removeTrack.call(this, track, pc, stream);
        });
    }
    release() {
        super.release();
        if (this.dvcConference) {
            this.dvcConference.setConferenceDisconnectedErrorCallback(null);
        }
        this.dvc = null;
        this.dvcConference = null;
        if (this.dvc2FakeAudioTrackHelper)
            this.dvc2FakeAudioTrackHelper.release();
    }
    setTransparentMode(transparent) {
        this.dvc.setTransparentMode(transparent);
    }
    setComfortNoiseLevel(level) {
        return this.dvc.setComfortNoise(level);
    }
    getComfortNoiseLevel() {
        return this.dvc.getComfortNoise();
    }
    conferenceDisconnectedErrorCallback(error) {
        this.emit('error', ConferenceDisconnectedError(error));
    }
    fatalErrorCallback() {
        this.dvc = null;
        this.dvcConference = null;
        this.emit('error', FatalError('DolbyVoice process has crashed, please reload your app.'));
    }
    addFakePeer(peerId) {
        let peer = this.peers.find((item) => item.peerId === peerId);
        if (!peer) {
            peer = {
                peerId: peerId,
                connection: null,
                stream: null,
                process: null,
                isMaster: false,
            };
            this.peers.push(peer);
        }
    }
    static throwIfNotSupported(obj, property) {
        if (!(property in obj))
            throw new Exceptions_1.UnsupportedError(`'${property}' is unsupported by ${obj.constructor.name} object. Please try the latest NDS version.`);
    }
}
exports.default = VoxeetRTCElectron;
